import React from 'react';

const Logo: React.FC<{ width?: number; height?: number; className?: string }> = ({ 
  width = 48, 
  height = 32, 
  className = '' 
}) => {
  return (
    <svg 
      version="1.1" 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink" 
      x="0px" 
      y="0px"
      width={width} 
      height={height}
      viewBox="0 0 278 185" 
      enableBackground="new 0 0 278 185" 
      xmlSpace="preserve"
      className={className}
    >
      <path
        fill="#06B6D4"
        opacity="1.000000"
        stroke="none" 
        d="
        M186.999954,169.207092 
          C149.224945,169.207062 111.949928,169.207062 74.184341,169.207062 
          C74.184341,143.978455 74.184341,119.237328 74.184341,93.960754 
          C67.506187,93.960754 61.290775,93.960754 55.075367,93.960754 
          C54.891598,93.585365 54.707832,93.209976 54.524067,92.834579 
          C83.481110,65.248184 112.438156,37.661785 142.103378,9.400742 
          C156.535965,24.600649 170.857635,39.683731 185.148254,54.734100 
          C197.850586,48.401157 209.105835,42.789665 221.303360,36.708405 
          C220.535248,38.586922 220.214874,39.748932 219.625244,40.752792 
          C214.736755,49.075924 209.988159,57.491318 204.784683,65.614532 
          C202.612518,69.005539 203.168442,70.871140 205.941788,73.509911 
          C212.434174,79.687279 218.533295,86.277939 225.399963,93.325607 
          C220.147858,93.325607 215.360977,93.325607 209.961807,93.325607 
          C209.961807,118.906288 209.961807,143.785095 209.961807,169.207138 
          C202.068008,169.207138 194.783981,169.207138 186.999954,169.207092 
        M156.832916,50.667370 
          C151.822067,45.595139 146.811203,40.522911 141.881332,35.532665 
          C140.923706,36.080471 140.424255,36.249798 140.079193,36.580315 
          C125.036453,50.988979 109.958038,65.361427 95.062912,79.921356 
          C93.759369,81.195564 93.116402,83.707825 93.102226,85.651855 
          C92.960022,105.150444 93.013809,124.650467 93.012428,144.150085 
          C93.012329,145.535843 93.012421,146.921600 93.012421,148.307358 
          C94.700081,147.236816 95.486862,146.032440 96.199417,144.785614 
          C107.598267,124.840111 118.903076,104.839806 130.485046,85.001282 
          C131.951157,82.489983 134.551697,80.237740 137.153793,78.863945 
          C147.406143,73.451149 157.868927,68.436996 170.270309,62.272446 
          C165.350052,58.043285 161.345551,54.601250 156.832916,50.667370 
        M191.138748,100.539825 
          C191.138748,96.959381 191.138748,93.378937 191.138748,89.798492 
          C184.299011,99.109093 178.485352,108.727303 172.370529,118.150085 
          C170.913391,120.395515 168.736862,122.507881 166.402542,123.795624 
          C152.266663,131.593750 137.985779,139.128876 123.763832,146.771393 
          C122.307831,147.553787 120.921143,148.465195 119.502281,149.316727 
          C119.647148,149.567657 119.792015,149.818604 119.936874,150.069534 
          C131.765335,150.069534 143.593811,150.069534 155.422272,150.069534 
          C167.192993,150.069534 178.963715,150.069534 190.506546,150.069534 
          C190.839706,149.121948 191.038177,148.819946 191.039032,148.517380 
          C191.083038,132.853943 191.110260,117.190483 191.138748,100.539825 
        M157.079849,102.192459 
          C156.901260,96.579353 154.596329,93.519875 150.142227,92.983734 
          C145.300980,92.401009 140.794861,95.339539 139.523407,100.075645 
          C138.427872,104.156441 139.946442,107.274803 143.582230,109.249878 
          C147.717209,111.496124 152.790909,109.975945 155.776978,105.691048 
          C156.330826,104.896294 156.590576,103.896599 157.079849,102.192459 
        z"
      />
      <path 
        fill="#FEFCFC" 
        opacity="1.000000" 
        stroke="none" 
        d="
        M157.086975,50.913292 
          C161.345551,54.601250 165.350052,58.043285 170.270309,62.272446 
          C157.868927,68.436996 147.406143,73.451149 137.153793,78.863945 
          C134.551697,80.237740 131.951157,82.489983 130.485046,85.001282 
          C118.903076,104.839806 107.598267,124.840111 96.199417,144.785614 
          C95.486862,146.032440 94.700081,147.236816 93.012421,148.307358 
          C93.012421,146.921600 93.012329,145.535843 93.012428,144.150085 
          C93.013809,124.650467 92.960022,105.150444 93.102226,85.651855 
          C93.116402,83.707825 93.759369,81.195564 95.062912,79.921356 
          C109.958038,65.361427 125.036453,50.988979 140.079193,36.580315 
          C140.424255,36.249798 140.923706,36.080471 141.881332,35.532665 
          C146.811203,40.522911 151.822067,45.595139 157.086975,50.913292 
        z"
      />
      <path 
        fill="#FEFDFC" 
        opacity="1.000000" 
        stroke="none" 
        d="
        M191.139008,101.033424 
          C191.110260,117.190483 191.083038,132.853943 191.039032,148.517380 
          C191.038177,148.819946 190.839706,149.121948 190.506546,150.069534 
          C178.963715,150.069534 167.192993,150.069534 155.422272,150.069534 
          C143.593811,150.069534 131.765335,150.069534 119.936874,150.069534 
          C119.792015,149.818604 119.647148,149.567657 119.502281,149.316727 
          C120.921143,148.465195 122.307831,147.553787 123.763832,146.771393 
          C137.985779,139.128876 152.266663,131.593750 166.402542,123.795624 
          C168.736862,122.507881 170.913391,120.395515 172.370529,118.150085 
          C178.485352,108.727303 184.299011,99.109093 191.138748,89.798492 
          C191.138748,93.378937 191.138748,96.959381 191.139008,101.033424 
        z"
      />
      <path 
        fill="#FEF9F8" 
        opacity="1.000000" 
        stroke="none" 
        d="
        M157.032959,102.591980 
          C156.590576,103.896599 156.330826,104.896294 155.776978,105.691048 
          C152.790909,109.975945 147.717209,111.496124 143.582230,109.249878 
          C139.946442,107.274803 138.427872,104.156441 139.523407,100.075645 
          C140.794861,95.339539 145.300980,92.401009 150.142227,92.983734 
          C154.596329,93.519875 156.901260,96.579353 157.032959,102.591980 
        z"
      />
    </svg>
  );
};

export default Logo;
